import { useDeleteEntityApi } from "@/common/api/deleteEntityApi";
import { useProductStore } from "shared/products/stores/productStore";

export interface DeleteProductRequest {
  productId: string;
}

export interface DeleteProductSuccessResponse {
  ok: true;
}

export function useDeleteProduct() {

  const store = useProductStore();

  return useDeleteEntityApi({
    url: 'product',
    translate: (t) => t.products.actions.delete,
    async processOk(request) {
        store.remove(request.id);
        return Promise.resolve({
          ok: true
        });
    },
  });
}
